import { Scanner as QrScanner } from '@yudiel/react-qr-scanner';

const Scanner = ({ onClose, onDataScanned }) => {
  const handleScan = (detectedCodes) => {
    const scannedValue = detectedCodes?.[0]?.rawValue;

    if (scannedValue) {
      onDataScanned(scannedValue);
      onClose();
    }
  };

  const handleError = (err) => {
    console.error(err);
    alert(`An error occurred: ${err?.message || 'Unable to access the camera.'}`);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-4 w-full max-w-lg">
        <button type="button" onClick={onClose}>
          Close
        </button>
        <QrScanner
          onScan={handleScan}
          onError={handleError}
          formats={['qr_code']}
          scanDelay={300}
          constraints={{ facingMode: 'environment' }}
          classNames={{
            container: 'mt-3',
            video: 'w-full',
          }}
        />
      </div>
    </div>
  );
};

export default Scanner;
